module.exports = __webpack_public_path__ + "montserrat-thinitalic-webfont.9eef86048a218f1d0ca1.woff";


//////////////////
// WEBPACK FOOTER
// D:/Honda/Trunk/WizdomWebApp/Wizdom-Web-App/src/assets/fonts/montserrat-thinitalic-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-thinitalic-webfont.woff
// module chunks = styles